<div class="container-fluid ">

    <h4 class="">
        Share
        <i class="fa fa-times pointer float-right" (click)="dialogRef.close()"></i>
    </h4>
    <div class="row p-2">
        <p style="text-align:center;font-style: italic;
    font-size: 14px;
    color: #939393;width:100%;">
            Via
        </p>
        <div (click)="share(item)" class="col-6 col-md-6 social-media-share"
            *ngFor="let item of portals; let index=index;">
            <div class="link-container">
                <i class="fa {{item.class}} mx-1 "></i>
                <span>{{item.title}}</span>
            </div>
        </div>
        <div id="or">OR</div>
        <p style="text-align:center;font-style: italic;margin-bottom: 0;
font-size: 14px;
color: #939393;width:100%;">
            Click on link to copy
        </p>
        <div class="input-group form-group">
            <input (click)="copyLink(share_link)" id="share_link_input"
                style="cursor: pointer;background:white;box-shadow: none !important;" type="text" value="{{share_link}}"
                class="form-control" readonly>
            <div (click)="copyLink(share_link)" class="input-group-append">
                <i class="fa fa-copy input-group-text" style="cursor: pointer;"></i>
            </div>
        </div>
    </div>
    <mat-horizontal-stepper [linear]="isLinear" #stepper *ngIf="false">
        <mat-step [stepControl]="firstFormGroup">
            <ng-template matStepLabel>Copy Existing Template</ng-template>
            <div class=" row p-2 " style="padding-bottom: 0px !important;">
                <div class="col-md-12 col-xs-12 col-sm-12 pt-2 pb-2 p-0" style="padding-top: 9px "
                    *ngIf="smp_template.length> 0">
                    <!-- <input (click)="copyTemplate(smp_template_ref)" id="temp_body_input" style="cursor: pointer;background:white;box-shadow: none !important; width: 74%;"
                        type="text" value="{{smp_template_ref.temp_body}}" readonly> -->
                    <b>{{smp_template_ref.temp_title}}</b>
                    <a>
                        <i class="fa fa-angle-right fa-lg   float-right" style="padding-top: 3px;cursor: pointer;"
                            (click)="nextMedia()"></i>
                    </a>

                    <a>
                        <i class="fa fa-angle-left ml-2 mr-4 fa-lg float-right"
                            style="padding-top: 3px;cursor: pointer;" (click)="prevMedia()"></i>
                    </a>
                    <a>
                        <i class="float-right ml-2  mr-3"> {{smp_template_index}} of {{smp_template_length}}</i>
                    </a>

                </div>
                <!-- <div>
                            <mat-button-toggle (click)=" prevMedia()">
                                <i class="fa fa-angle-left"></i>
                            </mat-button-toggle>
                        </div> -->


                <!-- <div (click)="copyTemplate(smp_template_ref.temp_body)" class="input-group-append">
                    <i class="fa fa-copy input-group-text" style="cursor: pointer;line-height: 1.5;"></i>
                </div> -->
                <div *ngIf="smp_template.length> 0" class="col-md-12 p-0  m-0">
                    <div class="card mt-2 mb-2 p-2">

                        <div class="row" *ngIf="smp_template_ref.temp_body">
                            <!-- <div class="col-md-12 pt-2 pb-2">
                                <strong>Template</strong>
                            </div> -->
                            <div class="col-md-12 pt-2">
                                <p>{{smp_template_ref.temp_body}}</p>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- <div>
                            <mat-button-toggle (click)="nextMedia()">
                                <i class=" fa fa-angle-right"></i>
                            </mat-button-toggle>
                        </div> -->
                <div class="col-md-12 p-0 m-0 mt-4">
                    <button mat-button (click)="copyTemplate(smp_template_ref.temp_body,stepper)"
                        class="btn btn-default copy" style="color:white;background: #001433;">
                        <i style="color:white;" class="fa fa fa-copy" style="cursor: pointer;line-height: 1.5;"></i>
                        Copy
                    </button>
                    <p class="skip" (click)="skip(stepper)">Skip</p>
                </div>
            </div>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup">
            <ng-template matStepLabel>Share</ng-template>
            <!-- <h4>
                Share
                <i class="fa fa-times float-right" (click)="dialogRef.close()"></i>
            </h4> -->
            <div class="row p-2">
                <p style="text-align:center;font-style: italic;margin-bottom: 0;
            font-size: 14px;
            color: #939393;width:100%;">
                    Via
                </p>
                <div (click)="share(item.portal_id)" class="col-6 p-1 social-media-share"
                    *ngFor="let item of portals; let index=index;">
                    <div class="row">
                        <div class="col-4 text-center">
                            <!-- <img class="social-media-icon" src="{{item.portal_logo}}" alt=""> -->
                            <img class="social-media-icon" src="{{item.file_path}}" alt="">
                        </div>
                        <div class="col-8" style="font-size: 22px;">
                            {{item.portal_title}}
                        </div>
                    </div>
                </div>
                <div id="or">OR</div>
                <p style="text-align:center;font-style: italic;margin-bottom: 0;
        font-size: 14px;
        color: #939393;width:100%;">
                    Click on link to copy
                </p>
                <div class="input-group">
                    <input (click)="copyLink(share_link)" id="share_link_input"
                        style="cursor: pointer;background:white;box-shadow: none !important;" type="text"
                        value="{{share_link}}" class="form-control" readonly>
                    <div (click)="copyLink(share_link)" class="input-group-append">
                        <i class="fa fa-copy input-group-text" style="cursor: pointer;line-height: 1.5;"></i>
                    </div>
                </div>
            </div>
            <!-- <div class="row p-2">
                <div class="col-md-12">
                <div class="col-md-12 col-xs-12 col-sm-12  p-0 m-0">
                    <hr>

                </div>
            </div>  -->

        </mat-step>

    </mat-horizontal-stepper>
</div>